import { motion } from "framer-motion";

export function FullScreenLoader({ label = "Yuklanmoqda..." }: { label?: string }) {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-4"
      style={{ background: "var(--bg-base)" }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="flex h-12 w-12 items-center justify-center rounded-2xl"
        style={{
          background: "linear-gradient(135deg, var(--chart-1) 0%, var(--chart-2) 50%, var(--chart-6) 100%)",
          boxShadow: "0 0 40px rgba(139, 92, 246, 0.35)",
        }}
      >
        <span
          className="block h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white"
          aria-hidden
        />
      </motion.div>
      <p className="text-sm text-zinc-400">{label}</p>
    </div>
  );
}
